import { articlePlugin, loadCards } from './load'
// import Emoji from '_lib/emoji'
import { traverseArticle } from './dom'
window.hb__format = {} // 存处理内容的函数

class Article {
  constructor (source, data, options = {}) {
    this.source = source
    this.origin_data = data
    this.options = options
    this.cards = loadCards(this)
    this.type = this.getLinkType()
    this.client_width = setClientWidth()
    this.content = this.handleContent()
    this.triggerCardDataRequest()
  }

  handleContent () {
    let content = this.formatContent()
    content = this.handleSpecialHtml(content)
    return traverseArticle.call(this, content)
  }

  handleSpecialHtml (content) {
    content = content.replace(/(<figure.*?>|<\/figure>)/ig, '');
    content = content.replace(/(<figcaption.*?>|<\/figcaption>)/ig, '');
    content = content.replace(/&lt;/gi, '_-_&lt;_-_')
    content = content.replace(/&gt;/gi, '_-_&gt;_-_')
    content = content.replace(/data-link-type=\"text\"/g, 'data-link-type=\"text\" class="a-link"')
    content = content.replace(/src="\/\//g, `src="https:\/\/`)
    return content
  }

  // 格式化帖子（统一新老帖子）
  formatContent () {
    let output  = ''
    switch (this.type) {
      case 'new': {
        output =  this.origin_data.content[0].text
        break
      }
      case 'old': {
        let img_num = 0
        output =  this.origin_data.content.reduce((pre, cur) => {
          console.log(cur);
          switch (cur.type) {
            case 'text': {
              return pre += `<p>${cur.text}</p>`
            }
            case 'url': {
              return pre += `<a href="${cur.text}">${cur.text}</a>`
            }
            case 'img': {
              if (img_num < 3) {
                return pre += `<img src="${cur.url}" data-original="${cur.url}">`
              } else {
                var rect = calcImageWidth(cur.url, cur.width, cur.height, this.client_width)
                return pre += `<img src="https://cdn.max-c.com/heybox/dailynews/img/8852ab726f691652841cc27df2f864e6.jpg" ${this.currentLazyLoadAttr}="${cur.url}" style="width:${rect.width};height:${rect.height}" class="lazy">`
              }
            }
            case 'game': {
              return pre += `<img data-gameid="${cur?.app_info?.steam_appid}">`
            }
            default: {
              return pre
            }
          }
        }, '')
        break
      }
    }
    output = output.replace(/http\:\/\//g, 'https://')
    return output
  }


  // 判断帖子类型
  getLinkType () {
    if (this.origin_data.content[0]) {
      if (this.origin_data.content[0].type == 'html') {
        return 'new'
      } else {
        return 'old'
      }
    } else {
      throw new TypeError("帖子内容为空")
    }
  }

  // // 处理所有的内容
  // handleContentLineData (content) {
  //   const container = document.createElement('div')
  //   const content_list = []
  //   container.innerHTML = content
  //   for (let index = 0; index < container.childNodes.length; index++) {
  //     let node = container.childNodes[index]
  //     switch (node.tagName) {
  //       case 'H2': {
  //         console.log('[h2]: ', node);
  //         content_list.push(window.hb__format['main_title'].call(this, node))
  //         break
  //       }
  //       case 'H3': {
  //         console.log('[h3]: ', node);
  //         content_list.push(window.hb__format['sub_title'].call(this, node))
  //         break
  //       }
  //       case 'H4': {
  //         console.log('[h4]: ', node);
  //         content_list.push(window.hb__format['img_desc'].call(this, node))
  //         break
  //       }
  //       case 'BLOCKQUOTE': {
  //         console.log('[blockquote]: ', node);
  //         content_list.push(window.hb__format['blockquote'].call(this, node))
  //         break
  //       }
  //       case 'OL': {
  //         console.log('[ol]: ', node);
  //         content_list.push(window.hb__format['order_list'].call(this, node))
  //         break
  //       }
  //       case 'UL': {
  //         console.log('[ul]: ', node);
  //         content_list.push(window.hb__format['unorder_list'].call(this, node))
  //         break
  //       }
  //       case 'P': {
  //         let inner
  //         if (node.childNodes[0]) {
  //           if (inner = Array.from(node.childNodes).find(child=>child.tagName === 'IMG')) 
  //           {
  //             let card
  //             if (card = this.handleCustomeCard(inner), card.cpt) {
  //               content_list.push(card)
  //             } else {
  //               console.log('[img]: ', inner);
  //               content_list.push(window.hb__format['img'].call(this, inner))
  //             }
  //           }
  //           else if (inner = Array.from(node.childNodes).find(child=>child.tagName === 'IFRAME'))
  //           {
  //             console.log('[iframe]: ', inner);
  //             content_list.push(window.hb__format['iframe'].call(this, inner))
  //           }
  //           else {
  //             console.log('[p]: ', node);
  //             content_list.push(window.hb__format['text'].call(this, node))
  //           }
  //         } else {
  //           console.log('[uncatch]: ', node);
  //           // window.hb__format['text'].call(this, node.children[0])
  //         }
  //         break
  //       }
  //       default: {
  //         console.log('[other]: ', node);
  //       }
  //     }
  //     // container.children[0].remove()
  //   }
  //   return content_list
  // }

  // 处理帖子卡片 
  handleCustomeCard (node) {
    return Object.values(this.cards).reduce((pre,cur) => {
      return cur.addCards(pre)
    }, node)
  }

  // 触发卡片请求
  triggerCardDataRequest () {
    this.requests = {}
    Object.values(this.cards).forEach(cards => cards.request())
  }

  calcImageWidth (src, width, height, original) {
    var dpi = height / width
    if (original) {
      return {
        width: width + 'px',
        height: height + 'px'
      }
    } else if (src.indexOf('cdn.max-c.com/stickers') > 0) {
      var border = ~~(this.client_width * 0.3) + 'px'
      return {
        width: border,
        height: border
      }
    } else if (width <= 0.5 * this.client_width) {
      return {
        width: ~~this.client_width * 0.5 + 'px',
        height: ~~this.client_width * dpi * 0.5 + 'px'
      }
    } else if (width < this.client_width && width > 0.5 * this.client_width) {
      return {
        width: width + 'px',
        height: height + 'px'
      }
    } else {
      return {
        width: ~~this.client_width + 'px',
        height: ~~this.client_width * dpi + 'px'
      }
    }
  }
}

function setClientWidth () {
  var width = 0, height = 0
  if (window.screen && window.screen.width) {
    width = window.screen.width
    height = window.screen.height
  } else if ((typeof window.innerWidth) == 'number') {
    width = window.innerWidth
    height = window.innerHeight
  } else if (document.documentElement && document.documentElement.clientWidth) {
    width = document.documentElement.clientWidth
    height = document.documentElement.clientHeight
  } else {
    width = document.body.clientWidth
    height = document.body.clientHeight
  }
  return Math.min(Math.max(Math.min(width, height), 300), 640) - 24
}



export {
  articlePlugin,
  Article
}